import {ShellBase} from '@/entryPoints/lib/shell-base';

//Vue Components
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';

import VeeValidate, {ValidationProvider} from 'vee-validate';
import veevalidateConfig from '@/config/veevalidate.config';

class Shell extends ShellBase {
  constructor(pageComponents = {}, vueRouter = {}) {
    super({...pageComponents, PdlCollapse, PdlCollapseItem}, vueRouter);
  }

  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();

    this.loadVeeValidate();
  }

  loadVeeValidate() {
    window.VeeValidate = VeeValidate;
    this.vue.use(VeeValidate, veevalidateConfig);
    veevalidateConfig.addValidators();
    this.vue.component('ValidationProvider', ValidationProvider);
  }
}

export {Shell};
